import React from 'react';
import classnames from 'classnames';
import { AccentH5 } from 'scy/text';
import { uppercase } from 'scy/text/styles.mod.scss';

export default function Title({ className }) {
  return (
    <AccentH5 tag="h2" className={classnames(uppercase, className)}>
      Payment Method
    </AccentH5>
  );
}
